<template>
  <el-dialog
    title="审核"
    :visible.sync="showDialog"
    width="700px"
    :before-close="handleClose"
  >
    <div class="dlg-content">
      <el-form
        class="global-form"
        :model="formData"
        :rules="rules"
        ref="form"
        label-width="140px"
      >
        <el-row :span="24">
          <el-col :span="24">
            <el-form-item label="开票金额" prop="invoicePrice">
              <el-input-number
                v-model="formData.invoicePrice"
                :min="0"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="审核状态" prop="invoiceState">
              <el-select
                v-model="formData.invoiceState"
                clearable
                filterable
                placeholder="请选择审核状态"
              >
                <el-option
                  v-for="([key, value], index) of stateList"
                  :value="key"
                  :label="value"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :span="24">
          <el-col :span="24">
            <el-form-item
              label="发票附件"
              prop="invoiceList"
              :rules="[
                {
                  required: formData.invoiceState == 2 ? true : false,
                  message: '请上传发票附件',
                  trigger: 'change',
                },
              ]"
            >
              <el-upload
                class="upload-demo"
                :action="$apis.common.uploadUrl"
                multiple
                :on-success="(val) => handleSuccess(val, 'invoiceList')"
                :before-upload="beforeUpload"
                :file-list="invoiceList"
              >
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">
                  文件大小不能超过50MB~
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row :span="24">
          <el-col :span="24">
            <el-form-item label="申请附件" prop="fileList">
              <div v-if="formData.fileList && formData.fileList.length > 0">
                <el-image
                 v-for="(item, index) of formData.fileList"
                  :key="index"
                  style="width: 100px; height: 100px; margin-right: 10px;border:1px solid #eee;"
                  :src="item.filePrefix + item.fileUrl"
                  :preview-src-list="[item.filePrefix + item.fileUrl]"
                >
                </el-image>
              </div>
            </el-form-item>
          </el-col>
        </el-row> -->
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submitForm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { stateList } from '@/utils/dict.js'

export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    invoiceId: {
      type: String,
      default: ''
    },
    currentRow: {
      type: Object,
      default: () => {}
    }

  },
  data () {
    return {
      stateList: stateList,
      formData: {
        invoiceId: '',
        invoicePrice: '',
        invoiceState: '',
        fileList: [],
        invoiceList: []
      },
      rules: {
        invoicePrice: [{ required: true, message: '请输入开票金额', trigger: 'blur' }],
        invoiceState: [{ required: true, message: '请选择审核状态', trigger: 'change' }]

      }
    }
  },
  computed: {
    invoiceList () {
      return this.formData.invoiceList.map(file => {
        return {
          name: file.fileName,
          url: file.filePrefix + file.fileUrl
        }
      })
    },

    user () {
      return this.$store.state.user
    }
  },
  created () {
    console.log('this.currentRow: ', this.currentRow)
    this.formData = { ...this.currentRow, invoiceList: this.currentRow.invoiceList || [], res: this.currentRow.res || [] }

    // this.loadData()
  },
  methods: {
    // loadData () {
    //   this.loading = true
    //   this.$axios.get(this.$apis.invoiceManage.selectYgInvoiceByInvoiceId, {
    //     params: { invoiceId: this.invoiceId }
    //   }).then(res => {
    //     res.invoiceList = res.invoiceList || []
    //     res.fileList = res.fileList || []
    //     this.currentRow = res || {}
    // this.formData =res||{}
    //   }).finally(() => {
    //     this.loading = false
    //   })
    // },
    handleClose () {
      this.$emit('closeDlg')
    },
    submitForm () {
      console.log('user: ', this.user)

      this.$refs.form.validate().then(() => {
        const url = this.$apis.invoiceManage.updateYgInvoice
        this.$axios.post(url, {
          ...this.currentRow,
          invoiceId: this.invoiceId,
          invoicePrice: this.formData.invoicePrice,
          invoiceState: this.formData.invoiceState,
          invoiceList: this.formData.invoiceList
        }).then(() => {
          this.handleClose()
          this.$emit('successSave')
        })
      })
    },
    handleSuccess (res, filed) {
      this.formData[filed].push(res.data)
      this.$refs.form.validate(filed)
    },
    beforeUpload (file) {
      const isLt50M = file.size < (50 * 1024 * 1024)
      if (!isLt50M) {
        this.$message.error('上传文件大小不能超过 50MB!')
      }
      return isLt50M
    }
  }

}
</script>
<style scoped lang='scss'>
.form {
  margin-top: 30px;
  width: 100%;
}

.el-select,
.el-input-number {
  width: 90%;
}

.el-cascader {
  width: 100%;
}

.el-date-editor {
  width: 100%;
}
</style>
